import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!value) {
      return null;
    }

    if (moment(value).isAfter(moment().subtract(10, 's'))) {
      return 'now';
    }

    return moment(value).fromNow();
  }

}
